import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T, TPlainTextKey } from '../../../../../Translations';

interface Props {
  text: TPlainTextKey;
}

function InfoText({ text }: Props) {
  return (
    <div
      className={clsx(
        'w-full font-medium text-base underline decoration-dashed decoration-teal-600',
      )}
    >
      <T kind={text} />
    </div>
  );
}

export default observer(InfoText);
